import React, { useEffect, useState, useCallback } from 'react';
import moment from 'moment';
import { Image } from 'antd';

import { Text } from '../Text';
import { RowWithBorder, CampoDetalheConsulta } from './styles';
import { getDetalhesConsultaExterna, getImgMotoristaCNH } from '../../services';
import { CardAttachments } from '../CardAttachments';
import { ModalCentralizada } from '../ModalCentralizado/style';

export function DetalhesConsultaExterna(params) {
  const [detalhes, setDetalhes] = useState();
  const [imagensMotorista, setImagensMotorista] = useState([]);
  const [openModalImagem, setOpenModalImagem] = useState(false);

  const carregarImagensMotorista = useCallback(async () => {
    const listMgsMotorista = await Promise?.allSettled([
      getImgMotoristaCNH(params.detalhes?.cpf),
    ]).then(res => res.map(item => item?.value?.data));

    return setImagensMotorista(listMgsMotorista);
  }, [detalhes]);

  const inicializaDados = async () => {
    const response = await getDetalhesConsultaExterna(params.detalhes.id);
    carregarImagensMotorista();
    setDetalhes(response.motorista);
  };

  const abrirImagem = visible => {
    setOpenModalImagem(visible);
  };

  useEffect(() => {
    inicializaDados();
  }, []);

  return (
    <>
      <CardAttachments
        handlerOpenImg={() => abrirImagem(true)}
        imagens={imagensMotorista}
      />
      <ModalCentralizada
        open={openModalImagem}
        title="Anexo"
        footer={null}
        onCancel={() => abrirImagem(!openModalImagem)}
        style={{ display: 'flex', alignContent: 'center' }}
      >
        <Image width={350} src={imagensMotorista} />
      </ModalCentralizada>
      <RowWithBorder justify="space-between" gutter={[5, 2]}>
        {detalhes?.cpf && (
          <>
            <CampoDetalheConsulta span={6}>
              <Text span={6} title="Nome" value={detalhes?.nome || '-'} />
            </CampoDetalheConsulta>
            <CampoDetalheConsulta span={6}>
              <Text title="CPF" value={detalhes?.cpf || '-'} />
            </CampoDetalheConsulta>
            <CampoDetalheConsulta span={6}>
              <Text title="RG" value={detalhes?.rg || '-'} />
            </CampoDetalheConsulta>
            <CampoDetalheConsulta span={6}>
              <Text title="UF RG" value={detalhes?.ufRg || '-'} />
            </CampoDetalheConsulta>
            <CampoDetalheConsulta span={6}>
              <Text title="Nome da Mãe" value={detalhes?.nomeMae || '-'} />
            </CampoDetalheConsulta>
            <CampoDetalheConsulta span={6}>
              <Text title="Nome do Pai" value={detalhes?.nomePai || '-'} />
            </CampoDetalheConsulta>
            <CampoDetalheConsulta span={6}>
              <Text
                title="Naturalidade"
                value={detalhes?.naturalidade || '-'}
              />
            </CampoDetalheConsulta>
            <CampoDetalheConsulta span={6}>
              <Text
                title="Nascimento"
                value={
                  moment(detalhes?.dataNascimento).format('DD/MM/YYYY') || '-'
                }
              />
            </CampoDetalheConsulta>
            <CampoDetalheConsulta>
              <Text title="Telefone" value={detalhes?.telefone || '-'} />
            </CampoDetalheConsulta>
          </>
        )}
      </RowWithBorder>
    </>
  );
}
